export default {
    NONE: 0,
    DENY: 1,
    FORCE_CAPTCHA: 2,
    0: 'None',
    1: 'Deny',
    2: 'ForceCaptcha'
};